const faqs = [
  {
    question: "Does Ohio have its own regional passport agency?",
    answer:
      "Ohio does not have a state-level passport agency. The nearest regional passport agency for most of Ohio is the Chicago Passport Agency in downtown Chicago. Travelers in northern Ohio near the Michigan border may also consider the Detroit Passport Agency in Troy, Michigan. Both require appointments and proof of urgent travel.",
  },
  {
    question: "How fast can I get a passport in Ohio?",
    answer:
      "With Fast Passport Center's courier service, Ohio travelers can receive a passport in as little as 24 hours. Our standard expedited service ranges from 3 to 9 business days. Routine processing through the post office typically takes 6 to 13 weeks.",
  },
  {
    question: "Do I need to visit a passport acceptance facility in Ohio?",
    answer:
      "First-time applicants, minors, and those replacing lost or stolen passports must visit an acceptance facility (typically a post office, county clerk, or library). Many post offices across Ohio offer passport acceptance services by appointment. Renewals for adults can usually be done by mail without an in-person visit.",
  },
  {
    question: "Which Ohio airport should I fly from with an expired passport?",
    answer:
      "If your passport is expired or soon to expire, you should not book international travel until you have a valid passport in hand. Major Ohio international airports include John Glenn Columbus (CMH), Cleveland Hopkins (CLE), Cincinnati/Northern Kentucky (CVG), Dayton (DAY), and Akron-Canton (CAK).",
  },
  {
    question: "Can I renew by mail from Ohio?",
    answer:
      "Yes. If your most recent passport was issued when you were 16 or older, was issued within the last 15 years, is undamaged, and was issued in your current name (or you have legal documentation of a name change), you can renew by mail from Ohio using Form DS-82.",
  },
  {
    question: "Where is the best place to get a passport photo in Ohio?",
    answer:
      "CVS, Walgreens, UPS Store, FedEx Office, and Walmart locations are widely available across Ohio and most offer walk-in passport photo service. Independent photo studios in Cleveland, Columbus, and Cincinnati also provide passport photos with guaranteed compliance. Always verify the photo meets State Department requirements before submission.",
  },
];

export { faqs };

export default function OhioFAQSection() {
  return (
    <section id="faq" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Ohio Passport Questions
          </h2>
          <p className="text-gray-500 text-base leading-relaxed">
            Quick answers for travelers applying for passports across the state of Ohio.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <details
              key={i}
              className="group bg-white rounded-lg border border-gray-200 overflow-hidden"
            >
              <summary className="flex items-center justify-between cursor-pointer p-5 list-none">
                <span className="font-bold text-[#1A365D] text-sm pr-4">{faq.question}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className="ri-add-line text-[#1A365D] text-sm group-open:ri-subtract-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-gray-500 text-sm leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}